import Vue from 'vue';

export default {
  state: {
    investorPage: {
      content: '',
      preview: {
        url: '',
      },
    },
  },
  mutations: {
    setInvestorPage(state, data) {
      state.investorPage = data;
    },
  },
  actions: {
    getInvestorPage(store) {
      const path = 'investor';
      return Vue.prototype.$axios.get(path).then((resp) => {
        store.commit('setInvestorPage', resp.data);
        return resp.data;
      });
    },
  },
};
